<template>
  <div>
    <el-dialog
      :visible="applyDialogVisible"
      :show-close="false"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      top="0">
      <div slot="title" class="dialog-title dialog-top">
        <div class="dialog-detail">
          <span class="detail">{{ $t('退回申请') }}</span>
        </div>
        <img class="dialog-close" src="@/assets/images/close.png" alt="" @click="onClose"/>
      </div>

      <div class="form-content">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px">
          <el-form-item prop="returnAddress" :label="$t('退回地址')">
            <el-input type="input" v-model="form.returnAddress" class="width100" maxlength="200" :placeholder="$t('请输入')">
              <template slot="suffix">
                <i class="iconfont icondizhibao pointer" @click="open"></i>
              </template>
            </el-input>
          </el-form-item>
        </el-form>

        <el-table :data="tableData" border style="width: 100%">
          <el-table-column :label="$t('序号')" type="index" width="100"/>
          <el-table-column prop="waybillNo" :label="$t('运单号')" width="180"/>
          <el-table-column :label="$t('退回申请原因(手动填写)')">
            <template v-slot="scope">
              <el-input style="width: 100% !important;" v-model="scope.row.rebackTransferReason" :placeholder="$t('请输入内容')"/>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="footer">
        <el-button type="primary" class="close" @click="applyDialogVisible = false">{{ $t('取消') }}</el-button>
        <el-button type="primary" :loading="isLoading" @click="submitApply">{{ $t('提交申请') }}</el-button>
      </div>
    </el-dialog>
    <AddressBookDialog v-model="addressBookVisible" :selectType="3" @single-row-select="singleRowSelect" ref="address"/>
  </div>
</template>

<script>
import { getDefaultAddress } from '@/api/module/customer.js'
import { fetchProblemBatchApplyByReturn, fetchProblemReply } from '@/api/module/problemPiece.js'
import AddressBookDialog from '@/components/AddressBookDialog/index.vue'
import { RESPONSE_SUCCESS } from '@/constants/index.js'

export default {
  name: 'ProblemReturnApplyDialog',
  components: {
    AddressBookDialog,
  },
  inject: ['selectedRows', 'replytype'],
  data() {
    return {
      applyDialogVisible: false,
      addressBookVisible: false,
      isLoading: false,
      addressObject: null, // 地址对象
      form: {
        returnAddress: ''
      },
      rules: {
        returnAddress: { required: true, message: this.$t('请选择退回地址'), trigger: ['change', 'blur'] },
      },
      tableData: [],
      selectedData: [] // 列表选中的数据
    }
  },
  watch: {
    applyDialogVisible() {
      this.selectedData = this.selectedRows()
    }
  },
  methods: {
    showDialog() {
      this.getDefaultAddress()
      this.applyDialogVisible = true
      this.tableData = this.selectedRows().map(item => {
        return {
          waybillNo: item.waybillNo,
          rebackTransferReason: '',
          returnAddressId: ''
        }
      })
    },
    /**
     * 打开地址薄
     */
    open() {
      this.addressBookVisible = true
      this.$refs['address'].updateBtnStatus(this.addressObject)
    },
    /**
     * 关闭弹窗
     */
    onClose() {
      this.applyDialogVisible = false
    },
    /**
     * 获取默认地址
     * @returns {Promise<void>}
     */
    async getDefaultAddress() {
      const param = {
        type: 3,
      }
      const { code, msg, data } = await getDefaultAddress(param)
      if (code === RESPONSE_SUCCESS) {
        this.$nextTick(() => {
          if (data) {
            this.addressObject = data || ''
            this.form.returnAddress = `${data.name}/${data.mobile}/${data.provinceName}${data.cityName}${data.areaName}${data.detailedAddress}`
          }
        })
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 地址簿选择
     * @param data
     */
    singleRowSelect(data) {
      this.addressObject = data
      this.form.returnAddress = `${data.name}/${data.mobile}/${data.provinceName}${data.cityName}${data.areaName}${data.detailedAddress}`
    },
    /**
     * 提交申请
     */
    submitApply() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          let flag = false
          this.tableData.forEach(item => {
            item.returnAddressId = this.addressObject.id
            if (item.rebackTransferReason === '') flag = true
          })
          if (flag) return this.$message.error(this.$t('请填写对应退件申请原因'))

          try {
            this.isLoading = true
            const { code, msg } = await fetchProblemBatchApplyByReturn(this.tableData)
            if (code === RESPONSE_SUCCESS) {
              const ids = this.selectedData.map(item => item.id)
              const { code, msg } = await fetchProblemReply({
                ids: ids,
                clientInstruct: this.replytype()
              })
              this.isLoading = false
              if (code === RESPONSE_SUCCESS) {
                this.$message.success(this.$t('申请成功'))
                this.applyDialogVisible = false
                this.$emit('success')
              } else {
                this.$message.error(this.$t(msg))
              }
            } else {
              this.isLoading = false
              this.$message.error(this.$t(msg))
            }
          } catch (e) {
            // this.$message.error(e)
            console.log(e)
            this.isLoading = false
          }
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-top {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .dialog-detail {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .detail {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFangSC;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      font-weight: 600;
    }
  }

  .dialog-close {
    width: 16px;
    height: 16px;
    display: inline-block;
    cursor: pointer;
  }
}

.form-content {
  padding-bottom: 20px;

  .width100 {
    width: 400px !important;
  }
}

::v-deep {
  .el-dialog__footer {
    border-top: 1px solid #eee;
  }
}

.footer {
  text-align: center;

  .close {
    background: #ffffff;
    border: 1px solid #cccccc;
    color: black;
  }
}
</style>
